export const environment ={
  production: true,
  url_redirect: 'https://www.horizonsdigitalsolutions.com',

  api: {
    orders: 'https://api.madeforyouconcept.com/backoffice/orders',
    shops: 'https://api.madeforyouconcept.com/backoffice/shops',
    catalogs: 'https://api.madeforyouconcept.com/catalogs',
    orderId: 'https://services.internal.horizonsoptical.com/counter/orderid',
    router: 'https://api.madeforyouconcept.com/services/router',
    fits: 'https://api.madeforyouconcept.com/backoffice/tags',
    measures: 'https://api.madeforyouconcept.com/backoffice/measures/',
    thickness: 'https://360depict.invisionsmartoptical.com/',
    thickness_api: 'https://api.360depict.invisionsmartoptical.com/',
    settings: 'https://fits.madeforyouconcept.com/settings',
    crm: 'https://api.crm.internal.horizonsoptical.com',
    finish_fit: 'https://www.fits.retailservices.horizonsoptical.com/',
    fit_api: 'https://api.fits.retailservices.horizonsoptical.com/',
    metadata_tar_api: 'https://api.madeforyouconcept.com/backoffice/tags/create_tar',
    check_folder: 'https://api.madeforyouconcept.com/backoffice/tags/check_folder'
  },

  auth: {
    endpoint: 'https://api.madeforyouconcept.com/auth',
    key: 'gM87QkxPWyrJJcVJ'
  },

  catalogaccess: {
    bucketName: 'made4youconcept-catalogs',
    region: 'eu-west-1',
    identityPoolId: 'eu-west-1:9d86eb15-a1fd-4cde-9c8d-14676da682ae'
  }
};